import { Component, OnInit,ViewChild, ElementRef, AfterViewInit,HostListener  } from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { HelperService } from '../helper.service';
import { Http, Response,Headers } from '@angular/http';
import { NgForm } from '@angular/forms';
import { MessagingService } from "../messaging.service";
import { Observable} from 'rxjs';
// import { interval } from 'rxjs';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
   providers:[MessagingService,HelperService]
})
export class ChatComponent implements OnInit,AfterViewInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
 student_id=0;
  messages:any=[];
  chat;
  payload;
  student_email:any='';
  text='';
  student_name;
  interval: any;
  i=1;
  j=0;
    @ViewChild('chat_div') private chat_div: ElementRef;
    user=this.cookie.get('user_id');
    // const source = interval(10000);
    user_token= localStorage.getItem('access_token');
    private headers: Headers = new Headers({
    'Accept': 'application/json',
    'Authorization': "Bearer "+this.user_token
  });
  constructor(private msgService: MessagingService, private http: Http,private cookie:CookieService,private helper:HelperService,private activatedRouter:ActivatedRoute,private router:Router) { 
    this.activatedRouter.params.subscribe((params: Params) => {
      this.student_id = params['id'];
      this.student_email='';
    });
  //   this.interval = setInterval(() => {
  //    this.ngOnInit();
  // }, 1000);
  // Observable
  //     .interval(1000)
  //     .map(() => this.ngOnInit())
      //.subscribe(res =>)
     
      this.interval = setInterval(() => {
        this.ngOnInit();
     }, 1000);
  }

ngAfterViewInit() {

         this.scrollToBottom();
    
         
    }
    
  scrollToBottom(): void {
    //alert("sefs");
        try {
            this.chat_div.nativeElement.scrollTop = this.chat_div.nativeElement.scrollHeight;
            
        } catch(err) { }                 
    }

  ngOnInit() {
    
    //this.i =0;
    // if(this.i==0)
    // {
    //   /alert(this.i);
    //   this.scrollToBottom();
    //   this.i = 1;
    // }
        

  this.msgService.getPermission(this.helper.base_url);
  this.msgService.receiveMessage(); 
  this.payload = this.msgService.currentMessage;

  this.msgService.currentMessage.subscribe(response  => {
   this.http.get(this.helper.base_url+'http/get/chat/'+this.student_id,{ headers: this.headers })
  
    .subscribe(data => {
    
      this.messages = JSON.parse(data['_body']);
      this.messages.forEach(value => {
    if(value.parent_id1!=null){
          this.student_email=value.email;
          this.student_name=value.studentname;
         return true;
        }
})
if(this.i ==1)
    {
this.scrollToBottomChat();

  
      this.i =5;  
    }

    //   this.messages.forEach(function(value) {
    //     if(value.parent_id1!=null){
    //       this.student_email=value.email;
    //      return true;
    //     }
    // });
          
    });
    // if(this.i ==1)
    // {
    //   alert("in");
      
        
    //     alert("going down");
       
    //   //this.i =2;  
    // }
    
});


if(this.i >3)
    {
var elem = document.getElementById('chatcard');
if(elem)
{
  //alert("in");
  elem.scrollTop = elem.scrollHeight;
  this.i =2;
}
}

  }

  scrollToBottomChat(){
    // alert("scroll");
    // var elem = document.getElementById('chatcard');
    //   if(elem)
    //   {
    //     alert("in");
    //     elem.scrollTop = elem.scrollHeight;
    //   }
  }
  
  
	add_form(addForm: NgForm){
    let user=this.cookie.get('user_id');
    let body = new FormData();
    body.append('chat', addForm.value.chat_text);
    body.append('user',this.user);
  

     this.http.post(this.helper.base_url+'http/add/chat/user/'+this.student_id, body,{ headers: this.headers })
     .subscribe(
       (data) => {
         this.text='';
        
         if(data['_body']!=''){
           this.messages = JSON.parse(data['_body']);
           this.messages.forEach(value => {
            if(value.parent_id1!=null){
                  this.student_email=value.email;
                 return true;
                }
        })
         }
       
       }, //For Success Response
        err => {console.error(err)} //For Error Response);
     );
   }
     backbtn(){
    window.history.back();
  }
  ngOnDestroy() {
    if (this.interval) {
      //alert("destroy");
      clearInterval(this.interval);
    }
  }
  routerOnDeactivate() {
    clearInterval(this.interval);
  }
  

}



// WEBPACK FOOTER //
// ./src/app/chat/chat.component.ts